<template>
  <h2>Split the card:</h2>
  <CardView :id="id"/>
  <div class="flex">
    <CardEdit :id="id" />
    <CardEdit  />
  </div>
</template>

<script>
import { supabase } from "../supabase";
import CardEdit from "../components/CardEdit.vue";
import CardView from "../components/CardView.vue";

export default {
  props: {
    id: String,
  },
  data() {
    return {
    };
  },
  components: {
    CardEdit,
    CardView,
  },

};
</script>